import styled from 'styled-components';
import theme from '~/ui/theme';
import { themeColor } from '~/common/utils/theme';
import { Typography } from '../Typography/Typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EventList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style-type: none;
`;

export const Label = styled(Typography).attrs({
  type: 'caption',
  element: 'p',
  weight: 500,
})`
  font-family: ${theme.typography.fonts[theme.typography.defaultFamily]};
  margin-bottom: 6px;
`;

export const Info = styled(Typography).attrs({
  type: 'caption',
  element: 'span',
})`
  font-family: ${theme.typography.fonts[theme.typography.defaultFamily]};
`;

export const Event = styled.li`
  display: flex;
  padding-bottom: 14px;
`;

export const IconContent = styled.div`
  position: relative;
  margin-right: 16px;
`;

export const Dot = styled.div`
  width: 16px;
  height: 16px;
  display: block;
  background-color: ${themeColor('brand.secondaryAlt')};
  border-radius: 16px;
  border: 4px solid ${themeColor('brand.secondary')};
`;

export const Line = styled.div`
  position: absolute;
  left: 0;
  width: 50%;
  border-right: 1px dashed;
  border-color: ${({ $isConected, theme: t }) => ($isConected ? t.colors.element.secondary : 'transparent')};
  height: 100%;
`;
